import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from "moment";

const $ = window.jQuery;

class DatePicker extends Component {
    static propTypes = {
        value: PropTypes.any.isRequired,
        onChange: PropTypes.func
    };
    static defaultProps = {};
    state = {};
    format = 'DD.MM.YYYY';

    componentDidMount() {
        const {value, onChange, ...props} = this.props;

        this.$el = $(this.el);
        this.$el.datepicker({
            autoclose: true,
            calendarWeeks: true,
            todayBtn: 'linked',
            clearBtn: true,
            todayHighlight: true,
            daysOfWeekHighlighted: '0,6',
            orientation: 'auto left',
            language: 'ru'
        });
        this.$el.on('changeDate', event => {
            if (onChange)
                onChange(moment(event.date).format("YYYY-MM-DD[T]HH:mm:[00]"), event);
        });
    }

    componentWillUnmount() {
        this.$el.off('change');
    }

    componentWillReceiveProps(nextProps) {
        this.$el.val(nextProps.value ? moment(nextProps.value).format(this.format) : '');
    }

    render() {
        const {value, onChange, ...props} = this.props;
        return (
            <input ref={el => this.el = el} type="text" {...props} />
        );
    }
}

export default DatePicker;


// WEBPACK FOOTER //
// ./src/controls/DatePicker.js